/* eslint-disable @typescript-eslint/ban-ts-comment */import*as allWidgets from"@airtel/air-widgets-library";import{View}from"react-native";// @ts-ignore
export var genericRendererKeyToWidgetsMap=Object.values(allWidgets).reduce(// @ts-ignore
(a,b)=>{// @ts-ignore genericRendererKey exist only on widgets from @airtel/air-widgets-library
var c=b.genericRendererKey;return c&&(a[c]=b),a},{AirGenericSection:View,// TODO remove
AirGenericSectionSPTesting:View});